import React, { lazy } from "react";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { useLocation } from "react-router-dom";
// import Loader from "../loader/Loader";
// import InfoPage from "../pages/infoPage/InfoPage";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import NewPricing from "../pages/subscription/NewPricing";
import Signup from "../pages/auth/Signup";
import { useEffect } from "react";

const HomePage = lazy(() => import("../pages/homePage/HomePage"));
// const MainPage = lazy(() => import("../pages/homePage/MainPage"));

const AboutUs = lazy(() => import("../pages/aboutUsPage/AboutUs"));
const Subscription = lazy(() => import("../pages/subscription/Subscription"));
const Blog = lazy(() => import("../pages/blogs/Blog"));
const BlogDetail = lazy(() => import("../pages/blogs/BlogDetail"));
const ContactUs = lazy(() => import("../pages/contactUs/ContactUs"));
const PrivacyPolicy = lazy(() => import("../pages/infoPages/PrivacyPolicy"));
// const AboutPage = lazy(() => import("../pages/infoPage/AboutPage"));
const Message = lazy(() => import("../pages/infoPages/Message"));

function MainLayout() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}
function RouterIndex() {
  return (
    <>
      <BrowserRouter basename="/">
        {/* <Header /> */}
        <Routes>
          <Route element={<MainLayout />}>
            {/* <Route path="/" element={<HomePage />} /> */}
            <Route path="/" element={<HomePage />} />
            {/* <Route path="/*" element={<HomePage />} /> */}
            <Route path="/about-us" element={<AboutUs />} />
            {/* <Route path="/subscription" element={<Subscription />} /> */}
            <Route path="/subscription" element={<NewPricing />} />

            <Route path="/blogs" element={<Blog />} />
            <Route path="/blogs/blog-details/:id" element={<BlogDetail />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/message" element={<Message />} />
            <Route path="/sign-up" element={<Signup />} />

            {/* <Route path="/about-us" element={<AboutPage />} />

          <Route path="/blogs/blog-detail/:id" element={<BlogDetail />} />

          {/* <Route path="info-page/:key" element={<InfoPage />} />
          <Route path="loader" element={<Loader />} />
          <Route path="/*" element={<HomePage />} />
           */}
            {/* <Route path="header" element={<Header />} /> */}
          </Route>
        </Routes>
        {/* <Footer /> */}
      </BrowserRouter>
    </>
  );
}

export default RouterIndex;
